// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4513":"475a5b6f","6030":"78a459eb"}[chunkId] + ".chunk.css";
};